module.exports = __webpack_public_path__ + "img/avatar-47.86b007b2.png";